/** Minúsculas y sin tildes, para buscar sin distinguir «Valparaíso» de «valparaiso». */
export function normalizar(s: string | null | undefined): string {
  return String(s ?? "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");
}

/** Todas las palabras de la consulta deben aparecer en alguno de los campos. */
export function coincide(campos: readonly (string | null | undefined)[], consulta: string): boolean {
  const pajar = normalizar(campos.join(" "));
  return normalizar(consulta)
    .split(/\s+/)
    .filter(Boolean)
    .every((palabra) => pajar.includes(palabra));
}
